/* @flow weak */
import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import DialogContent from 'components/DialogContent';
import * as React from 'react';
import TranscriptRequestActions from 'actions/TranscriptRequestActions';

class TranscriptRequestApproveView extends React.Component<$FlowFixMeProps, $FlowFixMeState> {
  state = { transcriptRequest: null, error: null };

  componentDidMount() {
    TranscriptRequestActions.confirm(this.token())
      .then(transcriptRequest => {
        this.setState({ transcriptRequest });
      })
      .catch(error => {
        this.setState({ error: error.message });
      });
  }

  token = () => {
    return this.props.params.token;
  };

  renderContinueButton = () => {
    return (
      <Button
        className="TranscriptRequestApproveView-continue_button"
        to="/landing"
        eventElementName="TranscriptRequestApproveView-continue_button">
        Log in to Remind
      </Button>
    );
  };

  renderError = () => {
    return (
      <DialogContent
        size="xsmall"
        title="Message history request"
        subtext="Message history already shared."
        glyph="disabled"
        glyphColor="lava">
        <BoxBody>{this.renderContinueButton()}</BoxBody>
      </DialogContent>
    );
  };

  renderIncludeAnnouncementHistory = () => {
    if (!this.state.transcriptRequest.getInclAnnouncements()) {
      return null;
    }
    return <li>Announcements for all classes</li>;
  };

  renderIncludeChats = () => {
    if (!this.state.transcriptRequest.getInclChat()) {
      return null;
    }
    return <li>Chat messages with students</li>;
  };

  render() {
    if (this.state.error) {
      return this.renderError();
    }

    const { transcriptRequest } = this.state;
    if (!transcriptRequest) {
      return <CenteredLoadingIndicator />;
    }

    const adminName = transcriptRequest.getRequestorName();
    return (
      <DialogContent
        size="xsmall"
        title="Message history request"
        subtext={`Your message history has been shared with ${adminName}.`}
        glyph="check"
        glyphColor="shamrock">
        <BoxBody>{this.renderContinueButton()}</BoxBody>
      </DialogContent>
    );
  }
}

export default TranscriptRequestApproveView;
